import { css } from "@emotion/react";
import { activeSegments, pastSegments } from "pages/RequestIndex/hooks";
import { Icon, useModal } from "swing-components";

import { useIsDesktop } from "~utils";

import { FilterChip } from "./FilterChip";
import { FilterModal } from "./FilterModal";
import { ThreadedData } from "./types";
import { countActiveFilters, isLocalStorageSet } from "./utils";

type FilterBarProps = ThreadedData;

export function FilterBar(props: FilterBarProps) {
  const { page, ls, setLs } = props;

  const isDesktop = useIsDesktop();

  const { openModal, closeModal } = useModal({
    component: <FilterModal onDismiss={() => closeModal()} {...props} />,
    modalOptions: {
      cssClass: isDesktop ? undefined : "action-sheet-modal",
      breakpoints: isDesktop ? undefined : [0, 1],
      initialBreakpoint: isDesktop ? undefined : 1,
    },
  });

  const activeFilters = countActiveFilters(ls);

  return (
    <div
      className="mw-800"
      css={css`
        width: 100%;
        overflow: scroll;
        margin-top: 16px;
        display: flex;
        position: relative;
        -ms-overflow-style: none;
        scrollbar-width: none;
        ::-webkit-scrollbar {
          display: none;
        }
      `}
    >
      <div
        css={css`
          position: sticky;
          left: 0;
          z-index: 2;
          padding: 0 16px;
          background: var(--ion-background-color);

          @media (min-width: 900px) {
            padding-left: 0px;
          }
        `}
      >
        <FilterChip selected={isLocalStorageSet(ls)} onClick={() => openModal()}>
          <Icon name="Filter" />
          {activeFilters > 0 && activeFilters}
        </FilterChip>
      </div>
      <div css={{ display: "flex", gap: 20, paddingRight: 16 }}>
        {(page == "active" ? activeSegments : pastSegments).map((item) => {
          return (
            <FilterChip
              key={item}
              selected={ls?.statuses?.includes(item) || false}
              showDismiss
              onClick={() => {
                setLs((old) => {
                  const statuses = old.statuses ?? [];
                  if (statuses.includes(item)) {
                    return { ...old, statuses: statuses.filter((i) => i !== item) };
                  } else {
                    return { ...old, statuses: [...statuses, item] };
                  }
                });
              }}
            >
              <span css={{ textTransform: "capitalize" }}>{item}</span>
            </FilterChip>
          );
        })}
      </div>
    </div>
  );
}
